import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { CSSProperties } from 'react';
import Layout from './index';

const useStyles = makeStyles()(theme => ({
  root: {
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    gridArea: 'main',
    zIndex: 1000,
    ...(theme.mixins.scrollBar as CSSProperties),
  },
}));

/**
 * @description Wrapper which holds the main content of a page.
 *              This is the main scroll area for the page.
 */
const MainContent = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  const { classes, cx } = useStyles();
  return (
    <Box
      id={Layout.MAIN_CONTENT_ID}
      component="main"
      className={cx(className, classes.root)}
      tabIndex={-1}
    >
      {children}
    </Box>
  );
};

export default MainContent;
